/** 
 * EventBus
 * Defines expected events
 * disppatches events by type
 * handles event listeners by type
 **/
const eventBus  = {
    types : {
        AddingToCart : 'mx_shopify.cart.adding',
        AddedToCart : 'mx_shopify.cart.added',
        GettingCart : 'mx_shopify.cart.getting',
        CartUpdated : 'mx_shopify.cart.updated',
        RemovedFromCart : 'mx_shopify.cart.removed',
        QuantityUpdated : 'mx_shopify.quantity.updated',
        OptionsSelected : 'mx_shopify.options.selected',
        CartOpened : 'mx_shopify.cart.opened',
        AjaxCartRefreshed : 'mx_shopify.cart.ajax.refreshed'
    },
    dispatch( $event , $data ) {
        $data = typeof( $data ) !== 'undefined' ? $data : {};
        document.dispatchEvent(new CustomEvent( $event , { detail : $data }   ) );
    },
    on( $event , func ){
        document.addEventListener( $event , func );
    },
    off( $event , func ){
        document.removeEventListener( $event , func );						
    }
}

export default eventBus
